export default {
  'loanAccounts.refName': 'loanSummary',
  'loanAccounts.gridName': 'LoanAccounts',
  'loanAccounts.title': 'Loan Accounts',

  // Total Header Titles and Fields
  'loanAccounts.currentPrincipalField': 'currentPrincipal',
  'loanAccounts.currentAvailableField': 'currentAvailable',

  // Column Names
  // Fixed Columns
  'loanAccounts.accountName': 'Account Name',
  'loanAccounts.accountNumber': 'Account Number',
  'loanAccounts.accountType': 'Account Type',
  'loanAccounts.totalLoc': 'Credit Limit',
  'loanAccounts.currentPrincipal': 'Current Principal',
  'loanAccounts.currentAvailable': 'Current Available',
  'loanAccounts.paymentAmount': 'Payment Amount',
  'loanAccounts.paymentDueDate': 'Payment Due Date',
  'loanAccounts.interestRate': 'Interest Rate',

  // Optional Columns
  'loanAccounts.accruedInterest': 'Accrued Interest',
  'loanAccounts.amountDue': 'Amount Due',
  'loanAccounts.availableCredit': 'Available Credit',
  'loanAccounts.collateralType': 'Collateral Type',

  'loanAccounts.estimatedPayOffAmount': 'Estimated Pay Off Amount',
  'loanAccounts.feesDue': 'Fees Due',
  'loanAccounts.interestPerDay': 'Interest Per Day',
  'loanAccounts.issueDate': 'Issue Date',

  'loanAccounts.lastInterestPaymentAmount': 'Last Interest Payment Amount',
  'loanAccounts.lastInterestPaymentDate': 'Last Interest Payment Date',
  'loanAccounts.lastPaymentAmount': 'Last Payment Amount',
  'loanAccounts.lastPrincipalPaymentAmount': 'Last Principal Payment Amount',

  'loanAccounts.lastPrincipalPaymentDate': 'Last Principal Payment Date',
  'loanAccounts.lastYearInterest': 'Last Year Interest',
  'loanAccounts.lateChargesDue': 'Late Charges Due',
  'loanAccounts.lineOfCredit': 'Line of Credit',

  'loanAccounts.loanPayOffAmount': 'Loan Payoff Amount',
  'loanAccounts.loanTerm': 'Loan Term',
  'loanAccounts.loanTermType': 'Loan Term Type',
  'loanAccounts.maturityDate': 'Maturity Date',

  'loanAccounts.nextInterestPaymentDate': 'Next Interest Payment Date',
  'loanAccounts.nextPaymentAmountDue': 'Next  Payment Amount Due',
  'loanAccounts.nextPaymentDate': 'Next Payment Date',
  'loanAccounts.nextPaymentDueDate': 'Next Payment Due Date',

  'loanAccounts.pastDueDatePrincipal': 'Past Due Date Principal',
  'loanAccounts.pastDueDaysForInterest': 'Past Due Days For Interest',

  'loanAccounts.pastDueDaysPrincipal': 'Past Due Days Principal',
  'loanAccounts.pastDueInterestAmount': 'Past Due Interest Amount',
  'loanAccounts.pastDuePrincipal': 'Past Due Principal',
  'loanAccounts.statementDate': 'Statement Date',
  'loanAccounts.ytdInterest': 'YTD Interest',

  // tiered loans
  'tieredLoanAccounts.defaultViewTitle': 'All Tiered Loans',
  'tieredLoanAccounts.title': 'Tiered Loan Accounts',
  'tieredLoanAccounts.masterAcctNum': 'Master Account Number',
  'tieredLoanAccounts.creditLineNum': 'Credit Line/Note Number',
  'tieredLoanAccounts.totalLoc': 'Credit Limit',
  'tieredLoanAccounts.paymentDueDate': 'Payment Due Date',
  'tieredLoanAccounts.interestRate': 'Interest Rate'
};
